import { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const locations = [
  { name: "Shanghai", x: "87%", y: "40%" },
  { name: "Hong Kong", x: "79%", y: "42%" },
  { name: "Dongguan", x: "83%", y: "42%" },
  { name: "Singapore", x: "76%", y: "60%" },
  { name: "Bangladesh", x: "73%", y: "48%" },
  { name: "Vietnam", x: "78%", y: "55%" },
  { name: "Gurgaon", x: "70%", y: "50%" },
  { name: "Indonesia", x: "80%", y: "64%" },
];

function LocationPin({ name, x, y, index }: { name: string; x: string; y: string; index: number }) {
  const [hovered, setHovered] = useState(false);

  return (
    <Box
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      sx={{
        position: "absolute",
        left: x,
        top: y,
        transform: "translate(-50%, -50%)",
        cursor: "pointer",
      }}
    >
      {/* Ping animation */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          bgcolor: "primary.main",
          borderRadius: "50%",
          opacity: 0.75,
          animation: "ping 2s cubic-bezier(0,0,0.2,1) infinite",
          animationDelay: `${index * 0.2}s`,
          "@keyframes ping": {
            "0%": { transform: "scale(1)", opacity: 0.75 },
            "75%, 100%": { transform: "scale(2)", opacity: 0 },
          },
        }}
      />
      {/* Dot */}
      <Box
        sx={{
          position: "relative",
          width: 24,
          height: 24,
          bgcolor: "primary.main",
          borderRadius: "50%",
          border: "4px solid #fff",
          boxShadow: 3,
          transition: "all 0.3s",
          transform: hovered ? "scale(1.25)" : "scale(1)",
        }}
      />
      {/* Tooltip */}
      {hovered && (
        <Box
          sx={{
            position: "absolute",
            top: 32,
            left: "50%",
            transform: "translateX(-50%)",
            bgcolor: "grey.900",
            color: "common.white",
            px: 1.5,
            py: 0.75,
            borderRadius: 1,
            fontSize: "0.875rem",
            fontWeight: 500,
            whiteSpace: "nowrap",
            boxShadow: 6,
            pointerEvents: "none",
            zIndex: 10,
          }}
        >
          {name}
          <Box
            sx={{
              position: "absolute",
              top: -4,
              left: "50%",
              transform: "translateX(-50%) rotate(45deg)",
              width: 8,
              height: 8,
              bgcolor: "grey.900",
            }}
          />
        </Box>
      )}
    </Box>
  );
}

function WorldMap() {
  const worldMap = `${process.env.PUBLIC_URL}/assets/Anko_World-Map.png`;

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ position: "relative", width: "100%" }}>
        <Box
          component="img"
          src={worldMap}
          alt="World Map"
          sx={{ width: "100%", height: "auto" }}
        />
        {locations.map((loc, i) => (
          <LocationPin key={loc.name} name={loc.name} x={loc.x} y={loc.y} index={i} />
        ))}
      </Box>

      {/* Legend */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: { xs: 2, md: 4 },
          mt: 4,
          flexWrap: "wrap",
        }}
      >
        {locations.map((loc) => (
          <Box key={loc.name} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Box sx={{ width: 16, height: 16, bgcolor: "primary.main", borderRadius: "50%" }} />
            <Typography variant="body2" sx={{ fontWeight: 400 }}>
              {loc.name}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default WorldMap;
